<div class="margin-auto d-flex justify-content-center align-items-center">

    <h1>Page does not exist</h1>

</div>
